module.exports = __webpack_public_path__ + "static/media/jquery-logo.379fe880.png";